module.exports = __webpack_public_path__ + "img/card-reversed.9fa5123a.svg";